/**
 * SharedSectionRenderer — Live Preview renders through the EXACT same
 * renderer as the editor canvas (`renderSiteBlock`), just with editing
 * chrome turned off. Same component tree → same DOM → zero layout shift
 * when switching between Preview and Edit.
 */
import { renderSiteBlock } from './renderSiteBlock';

export function renderPreviewBlock(block, options = {}) {
  if (!block || !block.type) return null;
  const { palette, headingFont, radius, allProducts = [] } = options;
  return renderSiteBlock(block, {
    allProducts,
    tokens: { palette, headingFont, radius },
    readOnly: true,
  });
}

export default renderPreviewBlock;
